import { render, staticRenderFns } from "./Software.tab.vue?vue&type=template&id=093a1b05&"
import script from "./Software.tab.vue?vue&type=script&lang=ts&"
export * from "./Software.tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports